<template>
  <div class="status-bar">
    <div>9:41</div>
    <div>
      <i class="fas fa-signal"></i>
      <i class="fas fa-wifi ml-1"></i>
      <i class="fas fa-battery-full ml-1"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusBar'
}
</script>

<style scoped>
.status-bar {
  height: 44px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  font-size: 12px;
  color: #000;
}
</style> 